module.exports = __webpack_public_path__ + "img/76.895253dc.png";